import React from 'react';
import Section from "../../wwc/layout/Section/Section"
import Row from "../../wwc/layout/Row/Row"
import Column from "../../wwc/layout/Column/Column"
import Text from "../../wwc/text/Text/Text"
import GatsbyImage from '../../gatsby/image';

class Footer extends React.Component {
  render() {    
    const footer = this.props.data;
    return(
      <footer>
        <Section className="footer">
          <Row className="footer-logo align--center">
            <Column>
              <GatsbyImage imageName={footer.logo.image} />
            </Column>
          </Row>
          <Row>
            { 
              footer.items.map((item, index) => {
                const className = `icon icon--${item.icon}`
                return(
                  <Column lg="4" key={index}>
                    <Text className={className}>{item.body}</Text>
                  </Column>
                )
              })
            }
          </Row>
          <Row className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} {footer.copyright}</p>
          </Row>
        </Section>
      </footer>      
    )
  }
}

export default Footer;
